import {useMemo, useState} from 'react'

const useDialogForm = ({useModal}) => {
    const {
        fieldsCreate,
        fieldsEdit,
        handleOnClickRow,
        isLoading: isLoadingDialog,
        validationSchema,
    } = useModal()
    const [openDialog, setOpenDialog] = useState(false)

    const [itemId, setItemId] = useState(null)
    const fieldsFormDialog = useMemo(
        () => (itemId ? fieldsEdit : fieldsCreate),
        [itemId, fieldsEdit, fieldsCreate]
    )
    const handleDialog = (id) => {
        setItemId(id)
        setOpenDialog(true)
    }
    return {
        fieldsFormDialog,
        handleOnClickRow,
        handleDialog,
        setOpenDialog,
        openDialog,
        isLoadingDialog,
        itemId,
        validationSchema,
    }
}

export default useDialogForm
